import { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Button } from './ui/button';
import { UserCheck, UserX, Clock, Users } from 'lucide-react';
import { toast } from 'sonner';
import { API_URL as API } from '../config';

export function PendingRequests() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const response = await axios.get(`${API}/connections/pending`);
            setRequests(response.data);
        } catch (error) {
            console.error('Failed to fetch pending requests:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAction = async (requestId, action) => {
        try {
            await axios.put(`${API}/connections/respond/${requestId}`, { action });
            setRequests(requests.filter(req => req.id !== requestId));
            toast.success(`Request ${action === 'accept' ? 'accepted' : 'declined'}`);
        } catch (error) {
            toast.error('Failed to respond to request');
        }
    };

    if (loading) return <div className="p-4 text-center text-zinc-500">Loading requests...</div>;

    if (requests.length === 0) return null;

    return (
        <div className="rounded-xl border mb-2" style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}>
            <div className="p-4 border-b" style={{ borderColor: 'var(--border-subtle)' }}>
                <h2 className="font-lexend text-lg font-semibold flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
                    <Clock className="w-5 h-5 text-inclusion-gold" />
                    Pending Connection Requests
                </h2>
            </div>
            <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {requests.map((request) => (
                        <div key={request.id} className="p-4 rounded-lg border flex items-center justify-between" style={{ backgroundColor: 'var(--bg-page)', borderColor: 'var(--border-subtle)' }}>
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-inclusion-blue/20 flex items-center justify-center">
                                    <Users className="w-5 h-5 text-inclusion-blue" />
                                </div>
                                <div className="text-sm">
                                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>{request.sender_name || `User ${request.sender_id.substring(0, 8)}`}</div>
                                    <div className="text-xs" style={{ color: 'var(--text-muted)' }}>wants to connect</div>
                                </div>
                            </div>
                            <div className="flex gap-2">
                                <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-inclusion-green hover:bg-inclusion-green/10" onClick={() => handleAction(request.id, 'accept')}>
                                    <UserCheck className="w-4 h-4" />
                                </Button>
                                <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-inclusion-red hover:bg-inclusion-red/10" onClick={() => handleAction(request.id, 'decline')}>
                                    <UserX className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
